import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import logo from '../asset/image/icon.png';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const location = useLocation();
  const navigate = useNavigate();
  const isLanding = location.pathname === '/';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleLinkClick = (section: string) => {
    setActiveSection(section);
    setIsMenuOpen(false);
  };

  const navItem = (section: string, label: string) => {
    if (isLanding) {
      return (
        <li key={section} style={{ color: activeSection === section ? 'purple' : 'inherit' }}>
          <ScrollLink
            activeClass="active"
            to={section}
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            onSetActive={() => handleLinkClick(section)}
          >
            {label}
          </ScrollLink>
        </li>
      );
    }
    return (
      <li key={section}>
        <span
          className="cursor-pointer"
          onClick={() => {
            navigate('/');
            setTimeout(() => {
              const el = document.getElementById(section);
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }, 50);
          }}
        >
          {label}
        </span>
      </li>
    );
  };

  return (
    <div className="App">
      <nav className="bg-white border-gray-200 fixed w-full shadow-md" style={{ zIndex: '100' }}>
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          <RouterLink to="/" className="flex items-center space-x-3 rtl:space-x-reverse">
            <img src={logo} className="h-8" alt="Logo" />
            <span className="self-center text-2xl font-semibold whitespace-nowrap text-black logoHeader">
              Udemy Summary: Harness the Power of OpenAI
            </span>
          </RouterLink>
          <button
            data-collapse-toggle="navbar-default"
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-controls="navbar-default"
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
          <div
            className={`${isMenuOpen ? 'block' : 'hidden'} w-full md:block md:w-auto`}
            id="navbar-default"
          >
            <ul className="bg-white font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:bg-white cursor-pointer">
              {navItem('home', 'Home')}
              {navItem('Benefits', 'Benefits')}
              {navItem('about', 'About Enxtension')}
              {navItem('Pricing', 'Pricing')}
            </ul>
          </div>
        </div>
      </nav>

      {children}

      <footer id="newsletter">
        <div className="container">
          <div className="section-heading footer-heading">
            <h4>Udemy Summary: Harness the Power of OpenAI</h4>
          </div>
          <div className="flex flex-col sm:flex-row mx-auto">
            <div className=" flex justify-center w-full sm:w-1/3 p-4">
              <div className="footer-widget">
                <h4>Contact Us</h4>
                <p>NGUYEN MANH TIEN</p>
                <p>
                  <span>nguyentienm@gmail.com</span>
                </p>
              </div>
            </div>
            <div className=" flex justify-center w-full sm:w-1/3 p-4">
              <div className="footer-widget">
                <h4>Feature</h4>
                <ul>
                  <li>
                    <span>Summary a video </span>
                  </li>
                  <li>
                    <span>Download pdf full course</span>
                  </li>
                  <li>
                    <span>Summary full course</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className=" flex justify-center w-full sm:w-1/3 p-4">
              <div className="footer-widget">
                <h4>About Us</h4>
                <ul className="cursor-pointer">
                  {navItem('home', 'Home')}
                  {navItem('Benefits', 'Benefits')}
                  {navItem('about', 'About Enxtension')}
                  {navItem('Pricing', 'Pricing')}
                  <li>
                    <RouterLink to="/privacy-policy">Privacy Policy</RouterLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
